// Valuation repository — PSD §3.5, P1.16. Persistence layer.
// saveValuation MUST be called before the UI reads a run result (PSD §11.4).

import type { ValuationRecord } from './schema';
import { getDB } from './db';

export async function saveValuation(record: ValuationRecord): Promise<void> {
  const db = await getDB();
  await db.put('valuations', record);
}

export async function loadValuation(valuationId: string): Promise<ValuationRecord | undefined> {
  const db = await getDB();
  return db.get('valuations', valuationId);
}

export async function listValuationsByEntity(entityName: string): Promise<ValuationRecord[]> {
  const db = await getDB();
  const idx = db.transaction('valuations').store.index('byEntity');
  return (await idx.getAll(entityName)) as ValuationRecord[];
}

export async function listAllValuations(): Promise<ValuationRecord[]> {
  const db = await getDB();
  return (await db.getAll('valuations')) as ValuationRecord[];
}
